// extracted by mini-css-extract-plugin
export default {"divBanner":"Home_divBanner__CobX7","page":"Home_page__+UCz3","blockThumb":"Home_blockThumb__nz27m"};